import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

import { ApiService } from '../api.service';
import { CrudService } from '../crud.service';

@Injectable({
    providedIn: 'root',
})
export class CategoriaService extends CrudService<any> {
    
    constructor(protected readonly api: ApiService) {
        super(api, `${environment.api}/categorias`);
    }
}
